import { Controller } from 'stimulus'
import { useIntersection } from 'stimulus-use'

export default class extends Controller {
    connect() {
        this.promotionId = this.element.dataset.promotionId;
        this.promotionName = this.element.dataset.promotionName;
        this.promotionCreativeName = this.element.dataset.promotionCreativeName;
        this.promotionCreativeSlot = this.element.dataset.promotionCreativeSlot;
        this.position = this.element.dataset.position;
    }

    manageClickPromotion(event)
    {
        let data = {
            id: this.promotionId,
            name: this.promotionName,
            creativeName: this.promotionCreativeName,
            creativeSlot: this.promotionCreativeSlot,
            position: this.position
        };

        EventManager.fire('gtm-event', {
            event: 'select_promotion',
            eventData: data
        });
    }
}